import { InputFieldSet } from "PFComponents/text/input_field_set";

import { ComponentProps } from "../component_prop_types";

type InputFieldSetWrapperProps = ComponentProps & { maxLength: number; onChange: (value: string) => void };

export const InputFieldSetWrapper = ({
  onChange,
  maxLength,
  label,
  error,
  value,
  qaId,
  required,
  disabled,
  variant,
  title,
  formattedTitle,
  tabIndex,
  style,
  inputRef
}: InputFieldSetWrapperProps) => (
  <InputFieldSet
    ref={inputRef}
    required={required}
    onChange={onChange}
    maxLength={maxLength}
    error={error}
    label={label}
    value={value}
    qaId={qaId}
    disabled={disabled}
    variant={variant}
    title={formattedTitle || title}
    aria-label={formattedTitle || title}
    tabIndex={tabIndex}
    style={style}
    {...(variant === "table" ? { autoSize: false, inputType: "textarea" } : {})}
  />
);
